module.exports = __webpack_public_path__ + "img/no-profile-photo.1a89b864.svg";